import { LDSAvatar, LDSCard } from "@resmed/lumina-design-system";
import { SELECT_ICON } from "../../utils/SVGHelper";

export interface ResidentSelectItemProps {
  name: string;
  room: string;
  mrn: string;
  status: string;
  isSelected?: boolean;
  avatarImage?: string;
  avatarLabel?: string;
  onClick?: () => void;
}

const ResidentSelectItem = ({
  name,
  room,
  mrn,
  status,
  isSelected = false,
  avatarImage,
  avatarLabel,
  onClick,
}: ResidentSelectItemProps) => {
  const header = (
    <div className="lds-flex lds-flex-col lds-gap-2 lds-p-3">
      {/* Avatar or selected icon */}
      <div
        className={`lds-w-[60px] lds-h-[60px] lds-rounded-lg lds-flex lds-items-center lds-justify-center ${
          isSelected ? "lds-bg-surface-info-weak" : ""
        }`}
      >
        {isSelected ? (
          <img
            src={SELECT_ICON.src}
            alt={SELECT_ICON.alt}
            width={SELECT_ICON.width}
            height={SELECT_ICON.height}
          />
        ) : (
          <LDSAvatar
            size="medium"
            shape="circle"
            image={avatarImage}
            label={avatarLabel}
            imageFallback="default"
          />
        )}
      </div>

      {/* Name + Room */}
      <div>
        <p className="lds-text-sm lds-font-bold lds-leading-[125%] lds-tracking-normal lds-text-textcolor-default">
          {name}
        </p>
        <p className="lds-text-xs lds-font-normal lds-leading-[125%] lds-tracking-[0.04em] lds-text-textcolor-caption lds-mt-0.5">
          {room}
        </p>
      </div>
    </div>
  );

  const footer = (
    <div className="lds-flex lds-px-3 lds-pb-3">
      {/* MR# */}
      <div className="lds-flex lds-flex-col lds-gap-0.5 lds-w-1/2">
        <span className="lds-text-xs lds-font-semibold lds-leading-[125%] lds-tracking-[0.04em] lds-text-textcolor-default">
          MR#
        </span>
        <span className="lds-text-xs lds-font-normal lds-leading-[125%] lds-tracking-normal lds-text-textcolor-default">
          {mrn}
        </span>
      </div>

      {/* Status */}
      <div className="lds-flex lds-flex-col lds-gap-0.5 lds-w-1/2">
        <span className="lds-text-xs lds-font-semibold lds-leading-[125%] lds-tracking-[0.04em] lds-text-textcolor-default">
          Status
        </span>
        <span className="lds-text-xs lds-font-normal lds-leading-[125%] lds-tracking-normal lds-text-textcolor-default">
          {status}
        </span>
      </div>
    </div>
  );

  return (
    <LDSCard
      header={header}
      footer={footer}
      rootClassName={`lds-cursor-pointer lds-w-[160px] ${
        isSelected
          ? "lds-outline lds-outline-2 lds-outline-actions-primary-default"
          : ""
      }`}
      onClick={onClick}
    />
  );
};

export default ResidentSelectItem;
